import IconTemplate from '../../html/components/icon.html'

import Icons from '../../data/icons.json'

import Component from '../shared/component'

import {TooltipToggleMixin} from './tooltip'

export const Icon = Component('v-icon', {
  mixins: [
    TooltipToggleMixin
  ],
  template: IconTemplate,
  props: {
    id: {
      type: String,
      default: null,
      required: true,
      validator (value) {
        return value in Icons
      }
    },
    size: {
      type: [
        String,
        Number
      ],
      default: 12
    },
    color: {
      type: String,
      default: null,
      validator (value) {
        switch (value) {
          case '':
          case 'black':
          case 'gray':
          case 'white':
          case 'teal':
          case 'blue':
          case 'green':
          case 'green-dark':
          case 'red':
          case 'red-dark':
          case 'orange':
          case 'orange-dark':
            return true
          default:
            return false
        }
      }
    },
    spinning: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    classes () {
      return {
        [`is-${this.color}`]: this.color,
        'is-spinning': this.spinning
      }
    },

    viewBox () {
      return icon(this.id).viewBox
    },

    ratio () {
      const parts = this.viewBox.match(/0 0 (\d+) (\d+)/)
      return Number(parts[1]) / Number(parts[2])
    },

    svg () {
      return icon(this.id).children
    },

    labelledBy () {
      const {tooltip, $attrs} = this

      if (tooltip) {
        return tooltip.target
      }

      if ($attrs) {
        return $attrs['aria-labelledby']
      }
    }
  },
  methods: {
    append () {
      const { svg } = this.$refs

      if (this.svg) {
        const parsed = parse(this.svg)

        while (svg.firstChild) {
          svg.removeChild(svg.firstChild)
        }

        for (let i = 0, n = parsed.length; i < n; i++) {
          svg.appendChild(parsed[i].cloneNode(true))
        }
      }
    }
  },
  mounted () {
    this.append()
  },
  updated () {
    this.append()
  }
})

const CACHE = {}

const REGEX = /<svg.*?viewBox="(.*?)".*?>(.*)<\/svg>/

function icon (id) {
  if (CACHE[id] === undefined) {
    const svg = Icons[id]

    if (!svg) {
      return {}
    }

    const parts = svg.match(REGEX)

    CACHE[id] = {
      viewBox: parts[1],
      children: parts[2]
    }
  }

  return CACHE[id]
}

const PARSER = new DOMParser()

const PARSE_CACHE = {}

function parse (svg) {
  if (PARSE_CACHE[svg] === undefined) {
    const parsed = PARSER.parseFromString(
      `<svg xmlns='http://www.w3.org/2000/svg'>${svg}</svg>`,
      'text/xml'
    )

    PARSE_CACHE[svg] = parsed.documentElement.childNodes
  }

  return PARSE_CACHE[svg]
}
